/**
 * Form steps consultation script
 */
 class FinHub_FormStepsConsultation {
  constructor() {
    this.initState();
  }

  initState() {
    this.stepFormConsultationWrapper = $('.js-form-consultation');
    this.authStepForm = null;

    if (!this.stepFormConsultationWrapper.length) {
      return;
    }

    this.initFormConsultation();

    if (this.hasAuthStep()) {
      this.authStepForm = new FinHub_FormLoginOrRegister();
    }
  }

  initFormConsultation () {
    this.nextStepConsultationBtn = this.stepFormConsultationWrapper.find('.next-step');
    this.submitConsultation = this.stepFormConsultationWrapper.find('.btn-submit');
    this.prevStepConsultation = this.stepFormConsultationWrapper.find('.prev-step');
    this.consultationProgressBar = this.stepFormConsultationWrapper.find('.progress-bar');
    this.consultationProgressBarItem = this.consultationProgressBar.find('li');
    this.consultationFirstStepForm = this.stepFormConsultationWrapper.find('.form-step[data-step="1"]');
    this.consultationSecondStepForm = this.stepFormConsultationWrapper.find('.form-step[data-step="2"]');
    this.consultationThirdStepForm = this.stepFormConsultationWrapper.find('.form-step[data-step="3"]');
    this.consultationAdvisorId = parseInt(this.stepFormConsultationWrapper.find('form').attr('data-advisor-id'), 10);

    this.prevStepConsultation.on('click', e => {
      e.preventDefault();
      this.currentStep = 1;
      this.consultationProgressBarItem.eq(this.currentStep).removeClass('active');
      this.consultationProgressBarItem.eq(this.currentStep - 1).addClass('active');
      this.consultationFirstStepForm.addClass('active');
      this.consultationSecondStepForm.removeClass('active');
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#progress-bar").offset().top
      }, 100);
    });

    let formHelperStep1 = new FinHub_FormHelper(this.consultationFirstStepForm);
    let formHelperStep2 = new FinHub_FormHelper(this.consultationSecondStepForm);

    formHelperStep2.formDependencies([
      {
        useCollection: true,
        field: 'transaction-type-id',
        dependsOn: 'input[name="transaction_type_id"]',
        elementsToShow: (value) => this.consultationSecondStepForm.find('[data-transaction-type-id="' + value + '"]')
      },
      {
        field: 'is_need_finishing',
        dependsOn: 'input[name="transaction_type_id"], input[name="transaction_subject_id"]',
        showOn: () => {
          let selectedTransactionType = this.consultationSecondStepForm.find('input[name="transaction_type_id"]:checked');

          if (!selectedTransactionType.length) {
            return false;
          }
          
          let selectedTransactionTypeMarket = selectedTransactionType.eq(0).attr('data-type');
          let selectedSubject = this.consultationSecondStepForm.find('input[name="transaction_subject_id"]:checked');

          if (!selectedSubject.length) {
            return false;
          }

          let selectedSubjectNeedFinishing = selectedSubject.eq(0).attr('data-is-need-finishing');
          
          return selectedTransactionTypeMarket === 'PRIMARY_MARKET' && selectedSubjectNeedFinishing == '1';
        }
      },
      {
        field: 'need_finishing_amount',
        dependsOn: 'input[name="is_need_finishing"]',
        showOn: (value) => value == 1
      }
    ]);

    this.nextStepConsultationBtn.on('click', e => {
      e.preventDefault();
			let result = formHelperStep1.formValidate();
      this.currentStep = 1;

			if (result) {
        this.consultationFirstStepForm.addClass('is-loading');

        setTimeout(() => {
          this.consultationProgressBarItem.eq(this.currentStep).addClass('active');
          this.consultationFirstStepForm.removeClass('active');
          this.consultationSecondStepForm.addClass('active');
          this.consultationFirstStepForm.removeClass('is-loading');
          $([document.documentElement, document.body]).animate({
            scrollTop: $("#progress-bar").offset().top
          }, 100);
        }, 1000);
			}
    });

    this.submitConsultation.on('click', e => {
      e.preventDefault();
			let result = formHelperStep2.formValidate();
      this.currentStep = 2;

			if (result) {
        this.consultationSecondStepForm.addClass('is-loading');

        setTimeout(() => {
          this.consultationProgressBarItem.eq(this.currentStep).addClass('active');
          this.consultationSecondStepForm.removeClass('active');
          this.consultationThirdStepForm.addClass('active');
          this.consultationSecondStepForm.removeClass('is-loading');

          if (this.authStepForm) {
            this.authStepForm.showForm();
          } else {
            let form = this.stepFormConsultationWrapper.find('form');

            $.ajax({
              type: 'POST',
              url: form.attr('action'),
              data: form.serialize(),
              success: (data) => {
                this.consultationThirdStepForm.find('.advisor-image img').attr('src', data.adviser.image_url);
                this.consultationThirdStepForm.find('.advisor-name').text(data.adviser.name + ' ' + data.adviser.surname);
                $('.form-step-summary').removeClass('is-hidden');
                $('.wrapper[data-current-step]').addClass('is-sent-successfully');

                if (window.fbq != undefined) {
                  window.fbq('track', 'CompleteRegistration', {
                    content_name: (this.consultationAdvisorId).toString() 
                  });
                }
              }
            });
          }
        }, 1000);
			}
    });
  }

  hasAuthStep () {
    let authStep = $('.form-with-login-or-register .step-auth[data-url-email-exists]');

    if (authStep.length) {
      return true;
    }

    return false;
  }
}
